import React, { ReactElement, useContext, useState } from 'react';
import {
  ActivatingButton,
  Container,
  ButtonContainer,
  TableAndChartContainer,
  MobileShowHideContainer,
} from './TableAndChart.styles';
import { LocaleContext } from '../../context/LocaleContext';

export type TableAndChartProps = {
  children: ReactElement[],
  startWithChart?: boolean,
};

/**
 * This wrapper components shows toggle buttons on mobile to toggle between table and chart.
 * You have to add table and chart components as children in pairs.
 */
const TableAndChart = ({
  children,
  startWithChart,
}: TableAndChartProps): ReactElement => {
  const [chartActive, setChartActive] = useState(!!startWithChart);

  const { texts } = useContext(LocaleContext);

  const activateChart = (): void => {
    setChartActive(true);
  };
  const activateTable = (): void => {
    setChartActive(false);
  };

  return (
    <Container>
      <ButtonContainer>
        <ActivatingButton
          type="button"
          mode={chartActive ? 'outline' : 'solid'}
          label={texts.buttonTable}
          onClick={activateTable}
        />
        <ActivatingButton
          type="button"
          mode={chartActive ? 'solid' : 'outline'}
          label={texts.buttonChart}
          onClick={activateChart}
        />
      </ButtonContainer>

      {children.map((child, index) => {
        const isSecondEntry = !!(index % 2); // sequence of table child pairs
        if (!isSecondEntry) {
          return null;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <TableAndChartContainer key={`${index}`}>
            <MobileShowHideContainer active={!chartActive}>
              {children[index - 1]}
            </MobileShowHideContainer>
            <MobileShowHideContainer active={chartActive}>
              {children[index]}
            </MobileShowHideContainer>
          </TableAndChartContainer>
        );
      })}

    </Container>
  );
};

export default TableAndChart;
